import React, { useState } from 'react';
import {
  Button,
  Container,
  TextField,
  Box,
  Modal,
  Tooltip,
  Typography,
  Paper
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const AddNationality = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [NationalityName, setNationalityName] = useState('');
  const navigate = useNavigate();

  const handleSave = (e) => {
    e.preventDefault();
    if (NationalityName) {
      console.log('Nationality saved:', NationalityName);
      setShowSuccessModal(true);
    }
  };

  const handleCancel = () => {
    setNationalityName('');
  };

  return (
    <Container>
      <Box
        sx={{
          backgroundColor: 'rgba(2, 78, 101, 1)', // dark navy blue
          padding: '12px 16px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '0 auto',
          width: "100%",
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Add Nationality
        </Typography>
      </Box>

      <Paper elevation={3} style={{ 
        padding: 16, 
        width: '100%', 
        margin: 'auto', 
        marginTop: 6, 
        backgroundColor: '#f8fdfeff' 
      }}>
        <div>
          <TextField
            label="Nationality"
            variant="outlined"
            fullWidth
            value={NationalityName}
            onChange={(e) => setNationalityName(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Tooltip title={!NationalityName && "Enter Nationality"} arrow>
            <span>
              <Button
                variant="contained"
                onClick={handleSave}
                sx={{ 
                  mr: 2,
                  backgroundColor: '#127498ff',
                  '&:hover': { backgroundColor: '#116280ff' }
                }}
                disabled={!NationalityName}
              >
                SAVE
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
          >
            RESET
          </Button>
        </div>
      </Paper>

      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Nationality Added ✅
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Nationality Added Successfully
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default AddNationality;